import { observer } from 'mobx-react';
import React from 'react';

import { DbKey } from '../../../../adl-gen/common/db';
import { TrainingOffering } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { Loader, MaybeLoading } from '../../../../loader/loader';
import { Route } from '../../../../routing/app-routes';
import { PageLayoutFn } from '../../../../ui/common/page-layout/page-layout';
import { TrainingOfferingListAndData } from '../../../stores/training-offering-store';
import { ListView } from '../../common/list/list-view';
import {
  TrainingOfferingListView
} from '../../components/lists/training-offering-lists/training-offering-list-view';

interface TrainingOfferingScreenProps {
  pageLayout: PageLayoutFn;
  navigateTo(route: Route): void;

  data: MaybeLoading<TrainingOfferingListAndData>;

}

@observer
export class TrainingOfferingScreen extends React.Component<TrainingOfferingScreenProps> {
  onSelectTrainingOffering = async (id: DbKey<TrainingOffering>) => {
    this.props.navigateTo({
      route: 'admin',
      page: 'training-offering',
      id
    });
  };

  onCreateTrainingOffering = () => {
    this.props.navigateTo({
      route: 'admin',
      page: 'training-offering',
      view: 'new'
    });
  };

  renderTrainingOfferingList = observer((data: TrainingOfferingListAndData) => {
    return (
      <ListView
        list={data.list}
        fields={TrainingOfferingListView}
        refData={data.data}
        onSelect={this.onSelectTrainingOffering}
        onCreate={this.onCreateTrainingOffering}
      />
    );
  });

  TrainingOfferingsLoader = () => (
    <Loader state={this.props.data} LoadedComponent={this.renderTrainingOfferingList} />
  );

  renderContents = observer(() => {
    return <this.TrainingOfferingsLoader />;
  });

  render() {
    /// Title is required to ensure subnav gets rendered
    return (
      <this.props.pageLayout title={'Training Offerings'}>
        <this.renderContents />
      </this.props.pageLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/screens/training-offering-screen/training-offering-screen.tsx